import { FC } from "react";
import { Link } from "react-router-dom";

import { Classes, SimpleFn } from "web/types/Common";

import classify from "web/classify";

import defaultClasses from "./navigationItem.scss";

interface ICheckoutNavigationItem {
  label: string | number;
  enabled: boolean;
  active: boolean;
  classes: Classes;
  onClick: SimpleFn;
  isThankYouPageHelper: boolean;
  link: string;
}

const CheckoutNavigationItem: FC<ICheckoutNavigationItem> = ({
  label,
  enabled,
  active,
  classes,
  onClick,
  isThankYouPageHelper,
  link,
}) => {
  if (enabled) {
    return (
      <>
        <span
          className={classes.connector}
          data-t1="navigation_list_item_connector"
        />
        <Link
          to={link}
          onClick={onClick}
          className={classes.link}
          data-t1="navigation_list_item_label"
        >
          {label}
        </Link>
      </>
    );
  }
  if (active) {
    return (
      <>
        {isThankYouPageHelper ? (
          <span
            className={classes.connector}
            data-t1="navigation_list_item_connector"
          />
        ) : null}
        <span data-t1="navigation_list_item_label" className={classes.active}>
          {label}
        </span>
      </>
    );
  }

  return (
    <span data-t1="navigation_list_item_label" className={classes.disabled}>
      {label}
    </span>
  );
};

export default classify<ICheckoutNavigationItem>(defaultClasses)(
  CheckoutNavigationItem
);
